export default __webpack_public_path__ + "static/media/2104.106a3b00.png";